import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MappingsList from './mappings-list';

function Mappings() {
  return (
    <Switch>
      <Route exact path="/mappings" component={MappingsList} />
    </Switch>
  );
}

export default Mappings;
